module.exports = __webpack_public_path__ + "static/f43e68d5.britishIndianOceanTerritory.svg";